import { useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import StatementForm from './form';
import checkUser from '../actions/checkUser';

const reactAppData = window.itu_slot_form || {
  appSelector: '#root',
};
const { authUrl } = reactAppData;

const Switcher = () => {
  const [cookies] = useCookies();
  const [loggedIn, setLoggedIn] = useState(false);
  useEffect(() => {
    const verify = async () => {
      const user = await checkUser(cookies.ituAuth);
      setLoggedIn(user);
    };
    if (cookies.ituAuth) {
      verify();
    }
  }, [cookies.ituAuth]);

  return (
    <>
      {loggedIn ? (
        <StatementForm />
      ) : (
        <div className="ituContainer">
          <a className="ituBtn" href={authUrl}>
            Please login to request a policy statement slot
          </a>
        </div>
      )}
    </>
  );
};

export default Switcher;
